import styled from 'styled-components';

var TableBody = styled.tbody.withConfig({
  displayName: "TableBody",
  componentId: "sc-kxj7fk-0"
})([""]);

export { TableBody };
